import React from 'react';
import './Hero1.css';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-container">
      <div className="hero-content">
        <h1 className="hero-title">
          Your <span className="highlight">Trusted Legal Partner</span>
        </h1>
        <h3 className="hero-subtitle">
          Expert Legal Representation with Integrity, Dedication, and Results
        </h3>
        <p className="hero-description">
          With over 18 years of experience, we provide comprehensive legal solutions tailored 
          to your unique needs. Our commitment is to justice, transparency, and winning outcomes.
        </p>

        <div className="hero-buttons">
          <button className="btn-primary" onClick={()=>navigate("/consultation")}>
            Book A Consultation
          </button>
          <button className="btn-secondary" onClick={()=>navigate("/consultation")}>
            Get Started
          </button>
        </div>

        <div className="hero-stats">
          <div className="stat-item">
            <h2>500+</h2>
            <p>Cases Won</p>
          </div>
          <div className="stat-item">
            <h2>05+</h2>
            <p>Year Experience</p>
          </div>
          <div className="stat-item">
            <h2>92%</h2>
            <p>Success Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;